export default "__VITE_ASSET__C6qyxU9N__"